module.exports = __webpack_public_path__ + "img/55.ecdc8b97.png";